import { useEffect, useState } from "react";
import { ShieldCheck, BookOpenCheck, Users } from "lucide-react";
import { api } from "@/lib/api";
import { T } from "@/constants/testIds";

export default function TrustSection() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data)).catch(() => setStats(null));
  }, []);

  return (
    <section data-testid={T.trustSection} className="bg-subtle border-y border-border py-20 sm:py-28">
      <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-6">
          <span className="eyebrow">Editorial standards</span>
          <h2 className="heading-2 mt-3">
            Every article <em className="italic text-forest">reviewed</em> before publication.
          </h2>
          <p className="body-copy mt-6 text-ink-muted">
            Authors draft. Editors refine. Theological reviewers verify Scripture and doctrine. Translators localise
            with cultural care. Nothing goes public without careful review. Our published beliefs, editorial policy,
            and correction process are open and visible.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-6 sm:gap-10 text-sm">
            <div>
              <p className="eyebrow text-forest">Scripture-rooted</p>
              <p className="mt-2 text-ink-muted">Every doctrine tested by the Bible.</p>
            </div>
            <div>
              <p className="eyebrow text-forest">Reviewed</p>
              <p className="mt-2 text-ink-muted">Elder oversight on all doctrinal content.</p>
            </div>
            <div>
              <p className="eyebrow text-forest">Correctable</p>
              <p className="mt-2 text-ink-muted">Open corrections and versioning.</p>
            </div>
          </div>
        </div>

        <div className="md:col-span-6 grid grid-cols-2 gap-4">
          <StatCard icon={BookOpenCheck} label="Published articles" value={stats?.articles ?? "—"} />
          <StatCard icon={BookOpenCheck} label="Bible studies" value={stats?.bible_studies ?? "—"} />
          <StatCard icon={Users} label="Reviewing elders" value={stats?.reviewers ?? "—"} />
          <StatCard icon={ShieldCheck} label="Q&A entries" value={stats?.questions ?? "—"} />
        </div>
      </div>
    </section>
  );
}

function StatCard({ icon: Icon, label, value }) {
  return (
    <div className="paper-card p-6">
      <Icon className="h-5 w-5 text-forest" />
      <p className="font-serif text-4xl mt-4 text-ink" style={{ fontWeight: 500 }}>{value}</p>
      <p className="eyebrow mt-2">{label}</p>
    </div>
  );
}
